import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Form } from 'element-ui';

enum AccountType { Teacher = 'Teacher', SubAccount = 'SubAccount' }

@Component({
    components: {
        AccountTableComponent: () => import('./list.vue'),
    }
})
export default class TeacheraccountsComponent extends Vue {
    childAccountList: Array<any> = [];//子账号管理列表
    editList: Array<any> = [];//删除历史学习任务列表
    listLoading: Boolean = false;
    editLoading: Boolean = false;
    addLoading: Boolean = false;
    dialogRemark: Boolean = false;
    dialogPassword: Boolean = false;
    remark: String = '';
    password: String = '';
    accountId: number = 0;
    currentPage: number = 1;
    pageSize: number = 10;
    total: number = 10;
    editGroupId: number = 2;
    btnOpen: Boolean = true;
    btnClose: Boolean = true;
    btnPassword: Boolean = true;
    currAccoutType: string = AccountType.Teacher;
    /**添加子账号Begin**/
    groupList: Array<Object> = [];
    teachGroupList: Array<Object> = [];


    //子模块回调  / 点击返回
    jumpInfo(row) {



    }

    dialogChildAccount: Boolean = false;

    onAddAccountSubmit() {
        this.$refs.addChildAccountForm.validate((valid) => {
            if (valid) {
                this.addLoading = true;
                let model = (<any>Object).assign({}, this.addChildAccountForm);
                let para = [];
                para.push(model);
                let _thisa = this;
                this.axios({
                    method: 'post',
                    url: '/api/accounts/accountName/' + model.accountName,
                    transformResponse: [function (data) {
                        // 对 data 进行任意转换处理
                        if (data) {

                        }
                    }],
                    validateStatus: function (status) {
                        if (status == 412) {
                            _thisa.$message({
                                message: '账号重复',
                                type: 'error'
                            });
                        } else if (status == 200) {
                            _thisa.axios.post('/api/accounts?mark=Teacher', para).then((data) => {
                                _thisa.addLoading = false;
                                _thisa.$message({
                                    message: '提交成功',
                                    type: 'success'
                                });
                                _thisa.dialogChildAccount = false;
                            })
                        }
                    },
                });
            }
        })
    }

    onResetAccount() {
        this.$refs['addChildAccountForm'].resetFields();
    }

    $refs: {
        addChildAccountForm: Form,
        passwordForm: Form,
        multipleTable: Form,
        abc: Vue,
    };

    //初始化表单 Frozen冻结 Enable启用
    addChildAccountForm = {
        accountName: '',
        password: '',
        realName: '',
        remarks: '',
        status: 'Enable',
        groupId: '',
        groupName: ''
    }

    //新增界面校验规则
    addChildAccountFormRules: Object = {
        accountName: [
            {
                required: true,
                validator: (rule, value, callback) => {
                    if (value === '') {
                        callback(new Error('请输入账号名'));
                    } else if (!/^[\w]{4,16}$/.test(value)) {
                        callback(new Error('账号名为4-16位字符，只能有英文字母大小写、数字、下划线（无空格）组成'));
                    } else {
                        callback();
                    }
                },
                trigger: 'blur'
            }
        ],
        password: [
            {
                required: true,
                validator: (rule, value, callback) => {
                    if (value === '') {
                        callback(new Error('请输入初始密码'));
                    } else if (!/^[\w]{6,20}$/.test(value)) {
                        callback(new Error('密码为6-20位字符，只能由英文字母大小写、数字、下划线（无空格）组成'));
                    } else {
                        callback();
                    }
                },
                trigger: 'blur'
            }
        ],
        realName: [
            {
                required: true,
                validator: (rule, value, callback) => {
                    if (value === '') {
                        callback(new Error('请输入教师姓名'));
                    } else if (!/^[\u4e00-\u9fa5]{2,10}$/.test(value)) {
                        callback(new Error('姓名为2-10位中文字符（无空格）'));
                    } else {
                        callback();
                    }
                },
                trigger: 'blur'
            }
        ],
        remarks: [
            {
                validator: (rule, value, callback) => {
                    if (value === '') {
                        callback(new Error('请输入备注'));
                    } else if (!/^[\w]{0,50}$/.test(value)) {
                        callback(new Error('备注为0-50位字符，中文，英文，数字及符号（无空格）'));
                    } else {
                        callback();
                    }
                },
                trigger: 'blur'
            }
        ],
        groupId: [
            {
                required: true,
                validator: (rule, value, callback) => {
                    if (value === '') {
                        callback(new Error('请选择分组'));
                    } else {
                        callback();
                    }
                },
                trigger: 'blur'
            }
        ]
    }

    /**添加子账号End**/

    /**修改密码Begin**/
    passwordForm = {
        password: '',
        chekcPassword: ''
    }

    passwordFormRules: Object = {
        password: [
            {
                required: true,
                validator: (rule, value, callback) => {
                    if (value === '') {
                        callback(new Error('请输入用户密码'));
                    } else if (!/^[\w]{6,20}$/.test(value)) {
                        callback(new Error('密码为6-20位字符，只能由英文字母大小写、数字、下划线（无空格）组成'));
                    } else {
                        callback();
                    }
                },
                trigger: 'blur'
            }
        ],
        chekcPassword: [
            {
                required: true,
                validator: (rule, value, callback) => {
                    if (value === '') {
                        callback(new Error('请输入用户密码'));
                    } else if (!/^[\w]{6,20}$/.test(value)) {
                        callback(new Error('密码为6-20位字符，只能由英文字母大小写、数字、下划线（无空格）组成'));
                    } else if (value !== this.passwordForm.password) {
                        callback(new Error('两次输入密码不一致!'));
                    } else {
                        callback();
                    }
                },
                trigger: 'blur'
            }
        ]
    }

    onPasswordSubmit() {
        if (this.editList.length == 0) {
            this.$alert("请选择要修改密码的账号", '提示').catch(() => { });
            return false;
        }
        this.$refs.passwordForm.validate((valid) => {
            if (valid) {

                let para = [];
                let ids = "";

                this.editList.forEach(item => {
                    para.push(item.subUserId);
                });


                ids = para.join(',');
                para = [];

                this.axios.put('/api/accounts/password/' + ids + '?passWord=' + this.passwordForm.chekcPassword).then((data) => {
                    this.dialogPassword = false;
                    this.password = "";
                    if (data == undefined) {
                        this.$message({
                            message: '提交失败',
                            type: 'error'
                        });
                    } else {
                        this.$message({
                            message: '提交成功',
                            type: 'success'
                        });
                    }
                }).catch((error) => {
                    console.log(123);
                    this.$message({
                        message: '提交失败',
                        type: 'error'
                    });
                });
            } else {
                return;
            }
        })
    }
    /**修改密码End**/

    getGroupList() {
        this.axios.get('/api/groups').then((data) => {
            this.groupList = data.data;
        })
    }

    formChildAccount = {
        user: '',
        region: '',
        permissions: []//权限列表
    }

    handleSelectionChange(val) {

        this.editList = val;
        let seleList = this.editList;
        let isClose = false;
        let isOpen = false;
        if (seleList.length > 0) {
            this.btnPassword = false;
            seleList.forEach(item => {
                if (item.status == 1) {
                    isOpen = true;
                } else if (item.status == 0) {
                    isClose = true;
                }
            });
            this.btnClose = isClose;
            this.btnOpen = isOpen;

        } else {
            this.btnPassword = true;
            this.btnOpen = true;
            this.btnClose = true;
        }

    }

    onRemarkSubmit() {
        let id = this.accountId;
        let groupid: number = this.editGroupId;

        this.axios.put('/api/accounts/group/' + id + ' ?groupId=' + groupid).then((data) => {
            this.dialogRemark = false;
            this.$message({
                message: '提交成功',
                type: 'success'
            });
        });
    }

    editAccountPassword() {
        if (this.editList.length == 0) {
            this.$alert('请选择要修改密码的账号', '提示').catch(() => { });
            return false;
        }
        this.$refs['passwordForm'] && this.$refs['passwordForm'].resetFields();
        this.passwordForm.password = '';
        this.passwordForm.chekcPassword = '';
        this.dialogPassword = true;
    }

    closeAccount() {
        this.updateAccount("Frozen");
    }

    selectAddAccount(command) {
        let url = "";

        if (command == 'sigle') {
            //this.dialogChildAccount = true;
            (<any>this.$refs.abc).addAccount();

            //this.$refs['addChildAccountForm'].resetFields();
        } else {
            url = "/addmoreteacher";
            this.$router.push({
                path: url,
                query: {}
            });

        }
    }

    jumpGroup() {
        this.$router.push({
            path: '/teachergroups',
            query: {}
        });
    }

    updateAccount(operate) {
        let selectMsg = "";
        let errorMsg = "";
        let operaName = "";
        let para = [];
        let ids = "";
        switch (operate) {
            case "Frozen":
                selectMsg = "请选择要冻结的账号";
                errorMsg = "包含冻结账号";
                operaName = "Frozen";
                break;
            case "Enable":
                selectMsg = "请选择要启动的账号";
                errorMsg = "包含启动账号";
                operaName = "Enable";
                break;
            default:
                break;
        }

        if (this.editList.length == 0) {
            this.$alert(selectMsg, '提示').catch(() => { });
            return false;
        }
        //forEach 无法跳出循环，自定义方法或使用try来跳出
        try {
            this.editList.forEach(item => {
                if (item.status == operaName) {
                    throw new Error(errorMsg);
                } else {
                    para.push(item.subUserId);
                }
            });
           
        } catch (e) {
            para = [];
            this.$alert(e.message, '提示').catch(() => { });
            return false;
        }

        ids = para.join(',');
        para = [];

        this.axios.put('/api/accounts/' + ids + '?operation=' + operate).then((data) => {

            if (data.data.stateCode == '412') {
                this.$message({
                    message: data.data.message,
                    type: 'error'
                });
            } else {
                this.$message({
                    message: '提交成功',
                    type: 'success'
                });
                (<any>this.$refs.abc).getList();
            }
        });
    }

    openAccount() {
        this.updateAccount("Enable");
    }

    editRemark(row) {
        this.editGroupId = row.groupId;
        this.axios.get('/api/groups/' + row.parentId).then((data) => {
            this.teachGroupList = data.data;
        })

        this.accountId = row.accountId;
        this.dialogRemark = true;
    }

    mounted() {
        this.getGroupList();
    }
}